const version = 1;
export function referrerModifier(trackingId) {
    if (typeof document === 'undefined')
        return;
    // _ga-ss cookie made of 3 cookieParts -> version | trackingId | referrer
    const referrerCookie = getCookie('_ga-ss');
    const isViaGoogleAd = document.location.href.match(/(d|g)clid|utm_source/);
    const referrer = document.referrer;
    let trackingIds = [];
    let cookieReferrer, cookieVersion, cookieParts;
    if (!referrerCookie && !isViaGoogleAd)
        return;
    if (!!referrerCookie) {
        cookieParts = referrerCookie.split('|');
        cookieVersion = Number(cookieParts[0]);
        if (version === cookieVersion) {
            trackingIds =
                cookieParts[1].length > 0 ? cookieParts[1].split(',') : trackingIds;
            cookieReferrer = decodeURIComponent(cookieParts[2]);
        }
        if (!referrer)
            return setRefCookie(trackingIds, cookieReferrer);
    }
    if (cookieReferrer === referrer) {
        if (trackingIds.includes(trackingId)) {
            Object.defineProperty(document, 'referrer', {
                configurable: true,
                get: function () {
                    return '';
                }
            });
        }
    }
    else {
        if (!isViaGoogleAd) {
            // New referrer and no campaign params, we can dump the cookie entirely
            document.cookie =
                '_ga-ss=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; Path=/';
        }
        else {
            // First visit of a user from an ad, we register the _ga-ss cookie
            trackingIds = [trackingId];
            setRefCookie(trackingIds, referrer);
        }
    }
}
function setRefCookie(trackingIds, referrer) {
    document.cookie =
        '_ga-ss=' +
            [version, trackingIds.join(), encodeURIComponent(referrer)].join('|') +
            '; Expires=' +
            new Date(+new Date() + 1000 * 60 * 30).toUTCString() +
            '; Path=/';
}
function getCookie(cookieName) {
    cookieName = '; ' + cookieName + '=';
    const cookieStr = '; ' + document.cookie;
    if (cookieStr.indexOf(cookieName) > -1) {
        return cookieStr.split(cookieName)[1].split(';')[0];
    }
}
//# sourceMappingURL=referrerModifier.js.map